// 타이틀 시작 버튼 상태·데이터 문구(순수 함수). 시작 조건은 "캐릭터 모델 준비"뿐이고 전체 게임 데이터(수십 MB) 받기는 진입을 막지 않는다(RG-005).
import type { BundleStatus } from '../pwa/prefetch';

/** ready: 바로 시작 · loading: 준비 중(탭하면 예약) · queued: 예약됨(준비되면 자동 시작) · failed: 모델 실패(간이 모델로 시작 가능) */
export type TitleStartState = 'ready' | 'loading' | 'queued' | 'failed';
export interface TitleStartInput { ready: boolean; failed: boolean; queued: boolean }
export interface TitleStart { state: TitleStartState; label: string; /** 이 탭이 곧바로 시작을 보내는가 */ startNow: boolean }

export function titleStartState(i: TitleStartInput): TitleStart {
  if (i.ready) return { state: 'ready', label: '시작', startNow: true };
  if (i.failed) return { state: 'failed', label: '시작', startNow: true };
  if (i.queued) return { state: 'queued', label: '준비되면 바로 시작…', startNow: false };
  return { state: 'loading', label: '시작', startNow: false };
}

/** 준비 전 탭: 예약을 건다(이미 예약이면 그대로 유지). 준비된 뒤엔 예약이 필요 없다 */
export function titleQueueOnTap(i: TitleStartInput): boolean {
  return i.ready || i.failed ? false : true;
}

/** 예약이 걸려 있고 캐릭터 모델이 정상 준비됐을 때만 자동 시작(실패는 예약을 풀고 안내) */
export function titleShouldAutoStart(i: TitleStartInput): boolean {
  return i.queued && i.ready && !i.failed;
}

/** 준비 중 안내 문구(캐릭터 모델 진행률) */
export function titleLoadText(progress: number, attempts: number, queued: boolean): string {
  const pct = Math.max(0, Math.min(100, Math.floor(progress * 100)));
  return (attempts > 1 ? '캐릭터 모델을 다시 받는 중… ' : '모험을 준비하는 중… ') + pct + '%' + (queued ? ' · 끝나면 바로 시작해요' : ' · 곧 시작');
}

/** 준비 뒤 데이터 문구: 시작 조건처럼 읽히지 않게 "시작할 수 있어요"를 앞에, MB 숫자는 뒤에 */
export function titleDataText(st: BundleStatus): string {
  if (st.state !== 'running' || st.bytesTotal <= 0) return '시작할 수 있어요';
  const mb = (b: number): string => (b / (1024 * 1024)).toFixed(b >= 10 * 1024 * 1024 ? 0 : 1);
  return '시작할 수 있어요 · 나머지 그림·소리는 플레이하면서 받아요 ' + st.pct + '% (' + mb(st.bytesDone) + '/' + mb(st.bytesTotal) + ' MB)';
}
